<template>
  <v-data-table
    :headers="headers"
    :loading="loading"
    item-key="id"
    :items="materials"
    :search="search"
    no-data-text="Nothing to see here..."
    no-results-text="You filtered a little too hard there bud..."
  >
    <template v-slot:item.id="{ item }">
      <v-btn
        color="primary"
        rounded
        :to="{ name: 'MaterialDetail', params: { id: item.id } }"
      >
        <v-icon left>fas fa-barcode</v-icon>
        {{ item.id }} - 000
      </v-btn>
    </template>
    <template v-slot:item.customersupplied="{ item }">
      <v-icon v-if="item.customersupplied">check</v-icon>
      <v-icon v-else>exit</v-icon>
    </template>
    <template v-slot:item.children.length="{ item }">
      <v-badge>
        <template v-slot:badge>{{ item.children.length }}</template>
        <v-icon>grain</v-icon>
      </v-badge>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "MaterialsTable",
  props: {
    materials: {
      type: Array,
      required: true,
      default: () => []
    },
    loading: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      headers: [
        { text: "Barcode", align: "left", sortable: true, value: "id" },
        { text: "Name", sortable: "true", value: "name" },
        { text: "Powder", sortable: "true", value: "powder.name" },
        { text: "External", sortable: "true", value: "customersupplied" },
        { text: "Supplier", sortable: "true", value: "supplier.name" },
        { text: "Manufacturer", sortable: "true", value: "manufacturer.name" },
        { text: "Bags", sortable: "true", value: "children.length" }
      ]
    };
  }
};
</script>
